// // import { useState, useEffect, useCallback } from "react";
// // import { LayoutDashboard, Trash2, Clock, Sparkles, CheckCircle2, AlertCircle, Timer } from "lucide-react";
// // import DashboardLayout from "../../components/DashboardLayout";
// // import { useAuth } from "../../hooks/useAuth";
// // import { useNavigate } from "react-router-dom";
// // import { supabase } from "../../lib/supabaseClient";

// // // ─── Constants ────────────────────────────────────────────────────────────────
// // const COOLDOWN_MS = 15 * 60 * 1000; // 15 minutes

// // function getToday() {
// //   return new Date().toISOString().split("T")[0];
// // }

// // // ─── Status Config ────────────────────────────────────────────────────────────
// // function getStatusConfig(status) {
// //   switch (status) {
// //     case "on_the_way": return {
// //       label: "Valet On The Way",
// //       desc:  "Valet is heading to your property — approximately 15 min.",
// //       dot:   "#ff9800",
// //       bg:    "#fff3e0",
// //       border:"#ffb74d",
// //       color: "#e65100",
// //     };
// //     case "on_site": return {
// //       label: "Valet On-Site",
// //       desc:  "Valet has arrived. You can now submit your trash confirmation.",
// //       dot:   "#1565c0",
// //       bg:    "#e3f2fd",
// //       border:"#90caf9",
// //       color: "#1565c0",
// //     };
// //     case "completed": return {
// //       label: "Service Completed",
// //       desc:  "Today's valet trash service is done for your property.",
// //       dot:   "var(--g600)",
// //       bg:    "var(--g50)",
// //       border:"var(--g200)",
// //       color: "var(--g600)",
// //     };
// //     default: return {
// //       label: "Awaiting Service",
// //       desc:  "No active valet service right now. Check back soon.",
// //       dot:   "#bdbdbd",
// //       bg:    "#fafafa",
// //       border:"var(--ln)",
// //       color: "var(--mut)",
// //     };
// //   }
// // }

// // // ─── Cooldown Timer Display ───────────────────────────────────────────────────
// // function CooldownTimer({ endsAt, onExpire }) {
// //   const [remaining, setRemaining] = useState(Math.max(0, endsAt - Date.now()));

// //   useEffect(() => {
// //     if (remaining <= 0) { onExpire(); return; }
// //     const interval = setInterval(() => {
// //       const r = Math.max(0, endsAt - Date.now());
// //       setRemaining(r);
// //       if (r <= 0) { clearInterval(interval); onExpire(); }
// //     }, 1000);
// //     return () => clearInterval(interval);
// //   }, [endsAt, onExpire, remaining]);

// //   const mins = Math.floor(remaining / 60000);
// //   const secs = Math.floor((remaining % 60000) / 1000);

// //   return (
// //     <div style={{
// //       display: "flex", alignItems: "center", gap: 8,
// //       background: "#fff3e0", border: "1px solid #ffb74d",
// //       borderRadius: 10, padding: "10px 16px", marginTop: 12,
// //     }}>
// //       <Timer size={15} color="#e65100" />
// //       <span style={{ fontSize: 13, color: "#e65100", fontWeight: 600 }}>
// //         Next submission available in {mins}:{secs.toString().padStart(2, "0")}
// //       </span>
// //     </div>
// //   );
// // }

// // // ─── Confirm Modal ────────────────────────────────────────────────────────────
// // function ConfirmModal({ unitNumber, onConfirm, onCancel, loading }) {
// //   return (
// //     <div style={{
// //       position: "fixed", inset: 0, background: "rgba(0,0,0,.4)",
// //       display: "flex", alignItems: "center", justifyContent: "center",
// //       zIndex: 1000, padding: 16,
// //     }}>
// //       <div style={{
// //         background: "#fff", borderRadius: 16, padding: 28,
// //         width: "100%", maxWidth: 360,
// //         boxShadow: "0 8px 40px rgba(0,0,0,.16)",
// //         animation: "fadeUp .2s ease",
// //         textAlign: "center",
// //       }}>
// //         <div style={{
// //           width: 56, height: 56, borderRadius: "50%",
// //           background: "var(--g50)", border: "2px solid var(--g200)",
// //           display: "flex", alignItems: "center", justifyContent: "center",
// //           margin: "0 auto 16px",
// //         }}>
// //           <Trash2 size={24} color="var(--g600)" strokeWidth={1.8} />
// //         </div>

// //         <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", marginBottom: 8 }}>
// //           Confirm Trash Submission
// //         </div>
// //         <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 22 }}>
// //           You are submitting trash confirmation for{" "}
// //           <strong style={{ color: "var(--ink)" }}>Unit #{unitNumber}</strong>.
// //           <br />A 15-minute cooldown will apply after submission.
// //         </div>

// //         <div style={{ display: "flex", gap: 10 }}>
// //           <button onClick={onCancel} disabled={loading} style={{
// //             flex: 1, padding: "11px", borderRadius: 10,
// //             border: "1.5px solid var(--ln)", background: "#fff",
// //             cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)",
// //           }}>Cancel</button>
// //           <button onClick={onConfirm} disabled={loading} style={{
// //             flex: 2, padding: "11px", borderRadius: 10, border: "none",
// //             background: loading ? "var(--g300)" : "var(--g600)",
// //             cursor: loading ? "not-allowed" : "pointer",
// //             fontSize: 13, fontWeight: 700, color: "#fff",
// //           }}>
// //             {loading ? "Submitting…" : "Yes, I did ✓"}
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // // ─── Main Dashboard ───────────────────────────────────────────────────────────
// // export default function ResidentDashboard() {
// //   const { profile } = useAuth();
// //   const navigate    = useNavigate();
// //   const today       = getToday();

// //   const propertyId = profile?.property_id;
// //   const unitNumber = profile?.unit_number;
// //   const userId     = profile?.id;

// //   const NAV = [
// //   { label: "Dashboard", icon: LayoutDashboard, path: "/resident/dashboard", active: true },
// //   { label: "My Trash",  icon: Trash2,  path: "/resident/my-trash" },
// //   { label: "History",   icon: Clock,   path: "/resident/history" },
// //   { label: "Services",  icon: Sparkles, onClick: () => navigate("/resident/services") },
// // ];

// //   const [valetStatus,   setValetStatus]   = useState(null);   // on_the_way | on_site | completed | null
// //   const [submissions,   setSubmissions]   = useState([]);     // today's submissions
// //   const [showModal,     setShowModal]     = useState(false);
// //   const [submitting,    setSubmitting]    = useState(false);
// //   const [submitError,   setSubmitError]   = useState("");
// //   const [cooldownEnd,   setCooldownEnd]   = useState(null);   // timestamp ms
// //   const [cooldownDone,  setCooldownDone]  = useState(true);

// //   // ── Fetch valet status (today) ──
// //   const fetchValetStatus = useCallback(async () => {
// //     if (!propertyId) return;
// //     const { data } = await supabase
// //       .from("valet_status")
// //       .select("status")
// //       .eq("property_id", propertyId)
// //       .eq("service_date", today)
// //       .maybeSingle();
// //     setValetStatus(data?.status || null);
// //   }, [propertyId, today]);

// //   // ── Fetch today's submissions ──
// //   const fetchSubmissions = useCallback(async () => {
// //     if (!propertyId || !userId) return;
// //     const { data } = await supabase
// //       .from("activity_logs")
// //       .select("id, created_at, metadata")
// //       .eq("property_id", propertyId)
// //       .eq("user_id", userId)
// //       .eq("action", "resident_trash_submitted")
// //       .gte("created_at", `${today}T00:00:00`)
// //       .order("created_at", { ascending: false });
// //     setSubmissions(data || []);

// //     // Check cooldown from last submission
// //     if (data && data.length > 0) {
// //       const lastTime = new Date(data[0].created_at).getTime();
// //       const endsAt   = lastTime + COOLDOWN_MS;
// //       if (endsAt > Date.now()) {
// //         setCooldownEnd(endsAt);
// //         setCooldownDone(false);
// //       } else {
// //         setCooldownDone(true);
// //       }
// //     }
// //   }, [propertyId, userId, today]);

// //   useEffect(() => {
// //     fetchValetStatus();
// //     fetchSubmissions();
// //   }, [fetchValetStatus, fetchSubmissions]);

// //   // ── Realtime: valet_status changes ──
// //   useEffect(() => {
// //     if (!propertyId) return;
// //     const channel = supabase
// //       .channel("resident_valet_status")
// //       .on("postgres_changes", {
// //         event:  "*",
// //         schema: "public",
// //         table:  "valet_status",
// //         filter: `property_id=eq.${propertyId}`,
// //       }, () => {
// //         fetchValetStatus();
// //       })
// //       .subscribe();
// //     return () => supabase.removeChannel(channel);
// //   }, [propertyId, fetchValetStatus]);

// //   // ── Submit trash ──
// //   const handleSubmit = async () => {
// //     setSubmitting(true);
// //     setSubmitError("");
// //     try {
// //       const { error } = await supabase.from("activity_logs").insert({
// //         property_id: propertyId,
// //         user_id:     userId,
// //         action:      "resident_trash_submitted",
// //         metadata:    {
// //           unit_number:  unitNumber,
// //           service_date: today,
// //         },
// //       });
// //       if (error) throw error;

// //       // Start cooldown
// //       const endsAt = Date.now() + COOLDOWN_MS;
// //       setCooldownEnd(endsAt);
// //       setCooldownDone(false);
// //       setShowModal(false);
// //       fetchSubmissions();

// //     } catch (err) {
// //       setSubmitError(err.message || "Submission failed. Please try again.");
// //     }
// //     setSubmitting(false);
// //   };

// //   // ── Derived state ──
// //   const statusConfig  = getStatusConfig(valetStatus);
// //   const canSubmit     = valetStatus === "on_site" && cooldownDone;
// //   const todayCount    = submissions.length;

// //   return (
// //     <DashboardLayout role="resident" title="My Unit" navItems={NAV}>

// //       {/* Header */}
// //       <div className="fu" style={{ marginBottom: 24 }}>
// //         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--g600)", marginBottom: 6 }}>
// //           Resident Portal
// //         </div>
// //         <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 4 }}>
// //           Welcome home.
// //         </h2>
// //         <p style={{ fontSize: 13, color: "var(--mut)" }}>
// //           Unit <strong style={{ color: "var(--g700)" }}>#{unitNumber || "—"}</strong> · {today}
// //         </p>
// //       </div>

// //       {/* Today's Valet Status */}
// //       <div className="fu d1" style={{
// //         background: statusConfig.bg,
// //         border: `1.5px solid ${statusConfig.border}`,
// //         borderRadius: 14, padding: "18px 20px", marginBottom: 18,
// //         transition: "all .3s",
// //       }}>
// //         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
// //           Today's Service Status
// //         </div>
// //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// //           <div style={{
// //             width: 10, height: 10, borderRadius: "50%",
// //             background: statusConfig.dot, flexShrink: 0,
// //             boxShadow: valetStatus === "on_site" ? `0 0 0 3px ${statusConfig.dot}33` : "none",
// //           }} />
// //           <div>
// //             <div style={{ fontSize: 15, fontWeight: 700, color: statusConfig.color }}>
// //               {statusConfig.label}
// //             </div>
// //             <div style={{ fontSize: 12.5, color: "var(--mut)", marginTop: 3, lineHeight: 1.5 }}>
// //               {statusConfig.desc}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Trash Submission Button */}
// //       <div className="fu d2" style={{
// //         background: "#fff", borderRadius: 14,
// //         border: `1.5px solid ${canSubmit ? "var(--g300)" : "var(--ln)"}`,
// //         padding: "24px 20px", marginBottom: 18, textAlign: "center",
// //         transition: "border-color .3s",
// //       }}>
// //         <div style={{
// //           width: 60, height: 60, borderRadius: "50%",
// //           background: canSubmit ? "var(--g50)" : "#f5f5f5",
// //           border: `2px solid ${canSubmit ? "var(--g300)" : "#e0e0e0"}`,
// //           display: "flex", alignItems: "center", justifyContent: "center",
// //           margin: "0 auto 14px", transition: "all .3s",
// //         }}>
// //           <Trash2 size={26} color={canSubmit ? "var(--g600)" : "#bdbdbd"} strokeWidth={1.5} />
// //         </div>

// //         <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", marginBottom: 6 }}>
// //           Trash is out
// //         </div>

// //         <div style={{ fontSize: 13, color: "var(--mut)", marginBottom: 18, lineHeight: 1.6 }}>
// //           {valetStatus === "on_site"
// //             ? cooldownDone
// //               ? "Valet is on-site — tap below to confirm your submission."
// //               : "You already submitted. Wait for cooldown to submit again."
// //             : valetStatus === "on_the_way"
// //               ? "Button will activate when valet arrives on-site."
// //               : valetStatus === "completed"
// //                 ? "Today's service is complete."
// //                 : "Button activates when valet arrives on-site."
// //           }
// //         </div>

// //         {submitError && (
// //           <div style={{
// //             display: "flex", alignItems: "center", gap: 8,
// //             background: "#fef2f2", border: "1px solid #fecaca",
// //             borderRadius: 8, padding: "10px 14px", marginBottom: 14,
// //             fontSize: 13, color: "#dc2626", textAlign: "left",
// //           }}>
// //             <AlertCircle size={14} /> {submitError}
// //           </div>
// //         )}

// //         <button
// //           onClick={() => canSubmit && setShowModal(true)}
// //           disabled={!canSubmit}
// //           style={{
// //             background: canSubmit
// //               ? "linear-gradient(135deg, var(--g600), var(--g500))"
// //               : "#e0e0e0",
// //             color: canSubmit ? "#fff" : "#9e9e9e",
// //             border: "none", borderRadius: 10,
// //             padding: "13px 28px", fontSize: 14.5, fontWeight: 700,
// //             fontFamily: "'Outfit',sans-serif",
// //             cursor: canSubmit ? "pointer" : "not-allowed",
// //             width: "100%", maxWidth: 300,
// //             boxShadow: canSubmit ? "0 4px 14px rgba(34,107,65,.3)" : "none",
// //             transition: "all .3s",
// //           }}
// //         >
// //           {valetStatus === "on_site" && !cooldownDone
// //             ? "⏳ Cooldown active"
// //             : valetStatus === "on_site"
// //               ? "✓ Confirm Trash Submission"
// //               : "Not available yet"
// //           }
// //         </button>

// //         {/* Cooldown Timer */}
// //         {!cooldownDone && cooldownEnd && (
// //           <CooldownTimer
// //             endsAt={cooldownEnd}
// //             onExpire={() => setCooldownDone(true)}
// //           />
// //         )}

// //         {/* Today's count */}
// //         {todayCount > 0 && (
// //           <div style={{ marginTop: 14, fontSize: 12, color: "var(--mut)" }}>
// //             You submitted <strong style={{ color: "var(--g600)" }}>{todayCount}</strong> time{todayCount > 1 ? "s" : ""} today.
// //           </div>
// //         )}
// //       </div>

// //       {/* Upgrade Banner */}
// //       <div className="fu d3" style={{
// //         background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
// //         padding: "20px", marginBottom: 18,
// //       }}>
// //         <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink)", marginBottom: 4 }}>
// //           Upgrade Your Service
// //         </div>
// //         <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 12 }}>
// //           Get arrival notifications and enhanced cleanliness.
// //         </div>
// //         <button
// //           onClick={() => navigate("/resident/services")}
// //           style={{
// //             background: "var(--g600)", color: "#fff", border: "none",
// //             borderRadius: 8, padding: "8px 16px",
// //             fontSize: 13, fontWeight: 600, cursor: "pointer",
// //           }}
// //         >
// //           View Plans
// //         </button>
// //       </div>

// //       {/* Today's Submission History */}
// //       <div className="fu d4" style={{
// //         background: "#fff", borderRadius: 14, border: "1px solid var(--ln)", padding: "20px",
// //       }}>
// //         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 14 }}>
// //           Today's Submissions
// //         </div>

// //         {submissions.length === 0 ? (
// //           <div style={{ textAlign: "center", padding: "16px 0", color: "var(--mut)", fontSize: 13 }}>
// //             No submissions today yet.
// //           </div>
// //         ) : (
// //           <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
// //             {submissions.map((s, i) => (
// //               <div key={s.id} style={{
// //                 display: "flex", alignItems: "center", gap: 12,
// //                 padding: "11px 14px", borderRadius: 10,
// //                 background: "var(--g50)", border: "1px solid var(--g200)",
// //               }}>
// //                 <CheckCircle2 size={16} color="var(--g600)" strokeWidth={2} />
// //                 <div style={{ flex: 1 }}>
// //                   <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
// //                     Trash submitted — Unit #{unitNumber}
// //                   </div>
// //                   <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>
// //                     {new Date(s.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
// //                   </div>
// //                 </div>
// //                 {i === 0 && (
// //                   <span style={{
// //                     fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 20,
// //                     background: "var(--g600)", color: "#fff",
// //                     textTransform: "uppercase", letterSpacing: ".5px",
// //                   }}>Latest</span>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
// //         )}
// //       </div>

// //       {/* Confirm Modal */}
// //       {showModal && (
// //         <ConfirmModal
// //           unitNumber={unitNumber}
// //           onConfirm={handleSubmit}
// //           onCancel={() => { setShowModal(false); setSubmitError(""); }}
// //           loading={submitting}
// //         />
// //       )}

// //       <style>{`
// //         @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
// //       `}</style>
// //     </DashboardLayout>
// //   );
// // }


// import { useState, useEffect, useCallback } from "react";
// import { LayoutDashboard, Trash2, Clock, Sparkles, CheckCircle2, AlertCircle, Timer } from "lucide-react";
// import DashboardLayout from "../../components/DashboardLayout";
// import { useAuth } from "../../hooks/useAuth";
// import { useNavigate } from "react-router-dom";
// import { supabase } from "../../lib/supabaseClient";

// // ─── Constants ────────────────────────────────────────────────────────────────
// const COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes

// function getToday() {
//   return new Date().toISOString().split("T")[0];
// }

// // ─── Status Config ────────────────────────────────────────────────────────────
// function getStatusConfig(status) {
//   switch (status) {
//     case "on_the_way": return {
//       label: "Valet On The Way",
//       desc:  "Valet is heading to your property — approximately 15 min.",
//       dot:   "#ff9800",
//       bg:    "#fff3e0",
//       border:"#ffb74d",
//       color: "#e65100",
//     };
//     case "on_site": return {
//       label: "Service in progress",
//       desc:  "Valet has arrived. You can now submit your trash confirmation.",
//       dot:   "#1565c0",
//       bg:    "#e3f2fd",
//       border:"#90caf9",
//       color: "#1565c0",
//     };
//     case "completed": return {
//       label: "Service Completed",
//       desc:  "Today's valet trash service is done for your property.",
//       dot:   "var(--g600)",
//       bg:    "var(--g50)",
//       border:"var(--g200)",
//       color: "var(--g600)",
//     };
//     default: return {
//       label: "Awaiting Service",
//       desc:  "No active valet service right now. Check back soon.",
//       dot:   "#bdbdbd",
//       bg:    "#fafafa",
//       border:"var(--ln)",
//       color: "var(--mut)",
//     };
//   }
// }

// // ─── Cooldown Timer Display ───────────────────────────────────────────────────
// function CooldownTimer({ endsAt, onExpire }) {
//   const [remaining, setRemaining] = useState(Math.max(0, endsAt - Date.now()));

//   useEffect(() => {
//     if (remaining <= 0) { onExpire(); return; }
//     const interval = setInterval(() => {
//       const r = Math.max(0, endsAt - Date.now());
//       setRemaining(r);
//       if (r <= 0) { clearInterval(interval); onExpire(); }
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [endsAt, onExpire, remaining]);

//   const mins = Math.floor(remaining / 60000);
//   const secs = Math.floor((remaining % 60000) / 1000);

//   return (
//     <div style={{
//       display: "flex", alignItems: "center", gap: 8,
//       background: "#fff3e0", border: "1px solid #ffb74d",
//       borderRadius: 10, padding: "10px 16px", marginTop: 12,
//     }}>
//       <Timer size={15} color="#e65100" />
//       <span style={{ fontSize: 13, color: "#e65100", fontWeight: 600 }}>
//         Next submission available in {mins}:{secs.toString().padStart(2, "0")}
//       </span>
//     </div>
//   );
// }

// // ─── Confirm Modal ────────────────────────────────────────────────────────────
// function ConfirmModal({ unitNumber, onConfirm, onCancel, loading }) {
//   return (
//     <div style={{
//       position: "fixed", inset: 0, background: "rgba(0,0,0,.4)",
//       display: "flex", alignItems: "center", justifyContent: "center",
//       zIndex: 1000, padding: 16,
//     }}>
//       <div style={{
//         background: "#fff", borderRadius: 16, padding: 28,
//         width: "100%", maxWidth: 360,
//         boxShadow: "0 8px 40px rgba(0,0,0,.16)",
//         animation: "fadeUp .2s ease",
//         textAlign: "center",
//       }}>
//         <div style={{
//           width: 56, height: 56, borderRadius: "50%",
//           background: "var(--g50)", border: "2px solid var(--g200)",
//           display: "flex", alignItems: "center", justifyContent: "center",
//           margin: "0 auto 16px",
//         }}>
//           <Trash2 size={24} color="var(--g600)" strokeWidth={1.8} />
//         </div>

//         <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", marginBottom: 8 }}>
//           Confirm Trash Submission
//         </div>
//         <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 22 }}>
//           You are submitting trash confirmation for{" "}
//           <strong style={{ color: "var(--ink)" }}>Unit #{unitNumber}</strong>.
//           <br />A 30-minute cooldown will apply after submission.
//         </div>

//         <div style={{ display: "flex", gap: 10 }}>
//           <button onClick={onCancel} disabled={loading} style={{
//             flex: 1, padding: "11px", borderRadius: 10,
//             border: "1.5px solid var(--ln)", background: "#fff",
//             cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)",
//           }}>Cancel</button>
//           <button onClick={onConfirm} disabled={loading} style={{
//             flex: 2, padding: "11px", borderRadius: 10, border: "none",
//             background: loading ? "var(--g300)" : "var(--g600)",
//             cursor: loading ? "not-allowed" : "pointer",
//             fontSize: 13, fontWeight: 700, color: "#fff",
//           }}>
//             {loading ? "Submitting…" : "Yes, I did ✓"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Main Dashboard ───────────────────────────────────────────────────────────
// export default function ResidentDashboard() {
//   const { profile } = useAuth();
//   const navigate    = useNavigate();
//   const today       = getToday();

//   const propertyId = profile?.property_id;
//   const unitNumber = profile?.unit_number;
//   const userId     = profile?.id;

//   const NAV = [
//     { label: "Dashboard", icon: LayoutDashboard, path: "/resident/dashboard", active: true },
//     { label: "My Trash",  icon: Trash2,          path: "/resident/my-trash" },
//     { label: "History",   icon: Clock,            path: "/resident/history" },
//     { label: "Services",  icon: Sparkles,         onClick: () => navigate("/resident/services") },
//   ];

//   const [valetStatus,  setValetStatus]  = useState(null);
//   const [submissions,  setSubmissions]  = useState([]);
//   const [showModal,    setShowModal]    = useState(false);
//   const [submitting,   setSubmitting]   = useState(false);
//   const [submitError,  setSubmitError]  = useState("");
//   const [cooldownEnd,  setCooldownEnd]  = useState(null);
//   const [cooldownDone, setCooldownDone] = useState(true);

//   const fetchValetStatus = useCallback(async () => {
//     if (!propertyId) return;
//     const { data } = await supabase
//       .from("valet_status")
//       .select("status")
//       .eq("property_id", propertyId)
//       .eq("service_date", today)
//       .maybeSingle();
//     setValetStatus(data?.status || null);
//   }, [propertyId, today]);

//   const fetchSubmissions = useCallback(async () => {
//     if (!propertyId || !userId) return;
//     const { data } = await supabase
//       .from("activity_logs")
//       .select("id, created_at, metadata")
//       .eq("property_id", propertyId)
//       .eq("user_id", userId)
//       .eq("action", "resident_trash_submitted")
//       .gte("created_at", `${today}T00:00:00`)
//       .order("created_at", { ascending: false });
//     setSubmissions(data || []);

//     if (data && data.length > 0) {
//       const lastTime = new Date(data[0].created_at).getTime();
//       const endsAt   = lastTime + COOLDOWN_MS;
//       if (endsAt > Date.now()) {
//         setCooldownEnd(endsAt);
//         setCooldownDone(false);
//       } else {
//         setCooldownDone(true);
//       }
//     }
//   }, [propertyId, userId, today]);

//   useEffect(() => {
//     fetchValetStatus();
//     fetchSubmissions();
//   }, [fetchValetStatus, fetchSubmissions]);

//   useEffect(() => {
//     if (!propertyId) return;
//     const channel = supabase
//       .channel("resident_valet_status")
//       .on("postgres_changes", {
//         event: "*", schema: "public", table: "valet_status",
//         filter: `property_id=eq.${propertyId}`,
//       }, () => fetchValetStatus())
//       .subscribe();
//     return () => supabase.removeChannel(channel);
//   }, [propertyId, fetchValetStatus]);

//   const handleSubmit = async () => {
//     setSubmitting(true);
//     setSubmitError("");
//     try {
//       const { error } = await supabase.from("activity_logs").insert({
//         property_id: propertyId,
//         user_id:     userId,
//         action:      "resident_trash_submitted",
//         metadata:    { unit_number: unitNumber, service_date: today },
//       });
//       if (error) throw error;
//       const endsAt = Date.now() + COOLDOWN_MS;
//       setCooldownEnd(endsAt);
//       setCooldownDone(false);
//       setShowModal(false);
//       fetchSubmissions();
//     } catch (err) {
//       setSubmitError(err.message || "Submission failed. Please try again.");
//     }
//     setSubmitting(false);
//   };

//   const statusConfig = getStatusConfig(valetStatus);
//   const canSubmit    = valetStatus === "on_site" && cooldownDone;
//   const todayCount   = submissions.length;

//   return (
//     <DashboardLayout role="resident" title="My Unit" navItems={NAV}>

//       {/* Header */}
//       <div className="fu" style={{ marginBottom: 24 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--g600)", marginBottom: 6 }}>
//           Resident Portal
//         </div>
//         <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 4 }}>
//           Welcome home.
//         </h2>
//         <p style={{ fontSize: 13, color: "var(--mut)" }}>
//           Unit <strong style={{ color: "var(--g700)" }}>#{unitNumber || "—"}</strong> · {today}
//         </p>
//       </div>

//       {/* Today's Valet Status */}
//       <div className="fu d1" style={{
//         background: statusConfig.bg,
//         border: `1.5px solid ${statusConfig.border}`,
//         borderRadius: 14, padding: "18px 20px", marginBottom: 18,
//         transition: "all .3s",
//       }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//           Today's Service Status
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           <div style={{
//             width: 10, height: 10, borderRadius: "50%",
//             background: statusConfig.dot, flexShrink: 0,
//             boxShadow: valetStatus === "on_site" ? `0 0 0 3px ${statusConfig.dot}33` : "none",
//           }} />
//           <div>
//             <div style={{ fontSize: 15, fontWeight: 700, color: statusConfig.color }}>
//               {statusConfig.label}
//             </div>
//             <div style={{ fontSize: 12.5, color: "var(--mut)", marginTop: 3, lineHeight: 1.5 }}>
//               {statusConfig.desc}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Trash Submission Button */}
//       <div className="fu d2" style={{
//         background: "#fff", borderRadius: 14,
//         border: `1.5px solid ${canSubmit ? "var(--g300)" : "var(--ln)"}`,
//         padding: "24px 20px", marginBottom: 18, textAlign: "center",
//         transition: "border-color .3s",
//       }}>
//         <div style={{
//           width: 60, height: 60, borderRadius: "50%",
//           background: canSubmit ? "var(--g50)" : "#f5f5f5",
//           border: `2px solid ${canSubmit ? "var(--g300)" : "#e0e0e0"}`,
//           display: "flex", alignItems: "center", justifyContent: "center",
//           margin: "0 auto 14px", transition: "all .3s",
//         }}>
//           <Trash2 size={26} color={canSubmit ? "var(--g600)" : "#bdbdbd"} strokeWidth={1.5} />
//         </div>

//         <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", marginBottom: 6 }}>
//           Trash is out
//         </div>

//         <div style={{ fontSize: 13, color: "var(--mut)", marginBottom: 18, lineHeight: 1.6 }}>
//           {valetStatus === "on_site"
//             ? cooldownDone
//               ? "Service in progress — tap below to confirm your submission."
//               : "You already submitted. Wait for cooldown to submit again."
//             : valetStatus === "on_the_way"
//               ? "Button will activate when valet arrives on-site."
//               : valetStatus === "completed"
//                 ? "Today's service is complete."
//                 : "Button activates when valet arrives on-site."
//           }
//         </div>

//         {submitError && (
//           <div style={{
//             display: "flex", alignItems: "center", gap: 8,
//             background: "#fef2f2", border: "1px solid #fecaca",
//             borderRadius: 8, padding: "10px 14px", marginBottom: 14,
//             fontSize: 13, color: "#dc2626", textAlign: "left",
//           }}>
//             <AlertCircle size={14} /> {submitError}
//           </div>
//         )}

//         <button
//           onClick={() => canSubmit && setShowModal(true)}
//           disabled={!canSubmit}
//           style={{
//             background: canSubmit
//               ? "linear-gradient(135deg, var(--g600), var(--g500))"
//               : "#e0e0e0",
//             color: canSubmit ? "#fff" : "#9e9e9e",
//             border: "none", borderRadius: 10,
//             padding: "13px 28px", fontSize: 14.5, fontWeight: 700,
//             fontFamily: "'Outfit',sans-serif",
//             cursor: canSubmit ? "pointer" : "not-allowed",
//             width: "100%", maxWidth: 300,
//             boxShadow: canSubmit ? "0 4px 14px rgba(34,107,65,.3)" : "none",
//             transition: "all .3s",
//           }}
//         >
//           {valetStatus === "on_site" && !cooldownDone
//             ? "⏳ Cooldown active"
//             : valetStatus === "on_site"
//               ? "✓ Confirm Trash Submission"
//               : "Not available yet"
//           }
//         </button>

//         {!cooldownDone && cooldownEnd && (
//           <CooldownTimer endsAt={cooldownEnd} onExpire={() => setCooldownDone(true)} />
//         )}

//         {todayCount > 0 && (
//           <div style={{ marginTop: 14, fontSize: 12, color: "var(--mut)" }}>
//             You submitted <strong style={{ color: "var(--g600)" }}>{todayCount}</strong> time{todayCount > 1 ? "s" : ""} today.
//           </div>
//         )}
//       </div>

//       {/* Upgrade Banner */}
//       <div className="fu d3" style={{
//         background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
//         padding: "20px", marginBottom: 18,
//       }}>
//         <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink)", marginBottom: 4 }}>
//           Upgrade Your Service
//         </div>
//         <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 12 }}>
//           Get arrival notifications and enhanced cleanliness.
//         </div>
//         <button
//           onClick={() => navigate("/resident/services")}
//           style={{
//             background: "var(--g600)", color: "#fff", border: "none",
//             borderRadius: 8, padding: "8px 16px",
//             fontSize: 13, fontWeight: 600, cursor: "pointer",
//           }}
//         >
//           View Plans
//         </button>
//       </div>

//       {/* Today's Submission History */}
//       <div className="fu d4" style={{
//         background: "#fff", borderRadius: 14, border: "1px solid var(--ln)", padding: "20px",
//       }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 14 }}>
//           Today's Submissions
//         </div>

//         {submissions.length === 0 ? (
//           <div style={{ textAlign: "center", padding: "16px 0", color: "var(--mut)", fontSize: 13 }}>
//             No submissions today yet.
//           </div>
//         ) : (
//           <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
//             {submissions.map((s, i) => (
//               <div key={s.id} style={{
//                 display: "flex", alignItems: "center", gap: 12,
//                 padding: "11px 14px", borderRadius: 10,
//                 background: "var(--g50)", border: "1px solid var(--g200)",
//               }}>
//                 <CheckCircle2 size={16} color="var(--g600)" strokeWidth={2} />
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
//                     Trash is out — Unit #{unitNumber}
//                   </div>
//                   <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>
//                     {new Date(s.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
//                   </div>
//                 </div>
//                 {i === 0 && (
//                   <span style={{
//                     fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 20,
//                     background: "var(--g600)", color: "#fff",
//                     textTransform: "uppercase", letterSpacing: ".5px",
//                   }}>Latest</span>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {showModal && (
//         <ConfirmModal
//           unitNumber={unitNumber}
//           onConfirm={handleSubmit}
//           onCancel={() => { setShowModal(false); setSubmitError(""); }}
//           loading={submitting}
//         />
//       )}

//       <style>{`
//         @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
//       `}</style>
//     </DashboardLayout>
//   );
// }



import { useState, useEffect, useCallback } from "react";
import { LayoutDashboard, Trash2, Clock, Sparkles, CheckCircle2, AlertCircle, Timer, PackageCheck } from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";

// ─── Constants ────────────────────────────────────────────────────────────────
const COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes

function getToday() {
  return new Date().toISOString().split("T")[0];
}

function formatTime12(timeStr) {
  if (!timeStr) return null;
  const [h, m] = timeStr.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hour  = h % 12 || 12;
  return `${hour}:${String(m).padStart(2, "0")} ${ampm}`;
}

// ─── Status Config ────────────────────────────────────────────────────────────
function getStatusConfig(status) {
  switch (status) {
    case "on_the_way": return {
      label: "Valet On The Way",
      desc:  "Valet is heading to your property — approximately 15 min.",
      dot:   "#ff9800", bg: "#fff3e0", border: "#ffb74d", color: "#e65100",
    };
    case "on_site": return {
      label: "Service in progress",
      desc:  "Valet has arrived. You can now submit your trash confirmation.",
      dot:   "#1565c0", bg: "#e3f2fd", border: "#90caf9", color: "#1565c0",
    };
    case "completed": return {
      label: "Service Completed",
      desc:  "Today's valet trash service is done for your property.",
      dot:   "var(--g600)", bg: "var(--g50)", border: "var(--g200)", color: "var(--g600)",
    };
    default: return {
      label: "Awaiting Service",
      desc:  "No active valet service right now. Check back soon.",
      dot:   "#bdbdbd", bg: "#fafafa", border: "var(--ln)", color: "var(--mut)",
    };
  }
}

// ─── Cooldown Timer ───────────────────────────────────────────────────────────
function CooldownTimer({ endsAt, onExpire }) {
  const [remaining, setRemaining] = useState(Math.max(0, endsAt - Date.now()));

  useEffect(() => {
    if (remaining <= 0) { onExpire(); return; }
    const interval = setInterval(() => {
      const r = Math.max(0, endsAt - Date.now());
      setRemaining(r);
      if (r <= 0) { clearInterval(interval); onExpire(); }
    }, 1000);
    return () => clearInterval(interval);
  }, [endsAt, onExpire, remaining]);

  const mins = Math.floor(remaining / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff3e0", border: "1px solid #ffb74d", borderRadius: 10, padding: "10px 16px", marginTop: 12 }}>
      <Timer size={15} color="#e65100" />
      <span style={{ fontSize: 13, color: "#e65100", fontWeight: 600 }}>
        Next submission available in {mins}:{secs.toString().padStart(2, "0")}
      </span>
    </div>
  );
}

// ─── Confirm Modal ────────────────────────────────────────────────────────────
function ConfirmModal({ unitNumber, onConfirm, onCancel, loading }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 360, boxShadow: "0 8px 40px rgba(0,0,0,.16)", animation: "fadeUp .2s ease", textAlign: "center" }}>
        <div style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--g50)", border: "2px solid var(--g200)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
          <Trash2 size={24} color="var(--g600)" strokeWidth={1.8} />
        </div>
        <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", marginBottom: 8 }}>Confirm Trash Submission</div>
        <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 22 }}>
          You are submitting trash confirmation for <strong style={{ color: "var(--ink)" }}>Unit #{unitNumber}</strong>.
          <br />A 30-minute cooldown will apply after submission.
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onCancel} disabled={loading} style={{ flex: 1, padding: "11px", borderRadius: 10, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
          <button onClick={onConfirm} disabled={loading} style={{ flex: 2, padding: "11px", borderRadius: 10, border: "none", background: loading ? "var(--g300)" : "var(--g600)", cursor: loading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>
            {loading ? "Submitting…" : "Yes, I did ✓"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function ResidentDashboard() {
  const { profile } = useAuth();
  const navigate    = useNavigate();
  const today       = getToday();

  const propertyId = profile?.property_id;
  const unitNumber = profile?.unit_number;
  const userId     = profile?.id;

  const NAV = [
    { label: "Dashboard", icon: LayoutDashboard, path: "/resident/dashboard", active: true },
    { label: "My Trash",  icon: Trash2,          path: "/resident/my-trash" },
    { label: "History",   icon: Clock,            path: "/resident/history" },
    { label: "Services",  icon: Sparkles,         onClick: () => navigate("/resident/services") },
  ];

  const [valetStatus,   setValetStatus]   = useState(null);
  const [submissions,   setSubmissions]   = useState([]);
  const [collectedIds,  setCollectedIds]  = useState(new Set());
  const [serviceWindow, setServiceWindow] = useState({ start: null, end: null });
  const [showModal,     setShowModal]     = useState(false);
  const [submitting,    setSubmitting]    = useState(false);
  const [submitError,   setSubmitError]   = useState("");
  const [cooldownEnd,   setCooldownEnd]   = useState(null);
  const [cooldownDone,  setCooldownDone]  = useState(true);

  const fetchValetStatus = useCallback(async () => {
    if (!propertyId) return;
    const { data } = await supabase.from("valet_status").select("status").eq("property_id", propertyId).eq("service_date", today).maybeSingle();
    setValetStatus(data?.status || null);
  }, [propertyId, today]);

  const fetchServiceWindow = useCallback(async () => {
    if (!propertyId) return;
    const { data } = await supabase.from("properties").select("service_window_start, service_window_end").eq("id", propertyId).maybeSingle();
    if (data) setServiceWindow({ start: data.service_window_start || null, end: data.service_window_end || null });
  }, [propertyId]);

  const fetchSubmissions = useCallback(async () => {
    if (!propertyId || !userId) return;
    const { data } = await supabase
      .from("activity_logs").select("id, created_at, metadata")
      .eq("property_id", propertyId).eq("user_id", userId)
      .eq("action", "resident_trash_submitted")
      .gte("created_at", `${today}T00:00:00`)
      .order("created_at", { ascending: false });
    setSubmissions(data || []);
    if (data && data.length > 0) {
      const endsAt = new Date(data[0].created_at).getTime() + COOLDOWN_MS;
      if (endsAt > Date.now()) { setCooldownEnd(endsAt); setCooldownDone(false); }
      else { setCooldownDone(true); }
    }
  }, [propertyId, userId, today]);

  const fetchCollectedIds = useCallback(async () => {
    if (!propertyId || !userId) return;
    const { data: subs } = await supabase.from("activity_logs").select("id")
      .eq("property_id", propertyId).eq("user_id", userId)
      .eq("action", "resident_trash_submitted")
      .gte("created_at", `${today}T00:00:00`);
    if (!subs || subs.length === 0) { setCollectedIds(new Set()); return; }
    const subIds = subs.map(s => s.id);
    const { data: collected } = await supabase.from("activity_logs").select("metadata")
      .eq("property_id", propertyId).eq("action", "valet_collected_trash")
      .gte("created_at", `${today}T00:00:00`);
    setCollectedIds(new Set((collected || []).map(d => d.metadata?.submission_id).filter(id => subIds.includes(id))));
  }, [propertyId, userId, today]);

  useEffect(() => {
    fetchValetStatus(); fetchSubmissions(); fetchCollectedIds(); fetchServiceWindow();
  }, [fetchValetStatus, fetchSubmissions, fetchCollectedIds, fetchServiceWindow]);

  // Realtime — valet status
  useEffect(() => {
    if (!propertyId) return;
    const ch = supabase.channel("resident_valet_status")
      .on("postgres_changes", { event: "*", schema: "public", table: "valet_status", filter: `property_id=eq.${propertyId}` }, fetchValetStatus)
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [propertyId, fetchValetStatus]);

  // Realtime — valet collects → update collected IDs instantly
  useEffect(() => {
    if (!propertyId) return;
    const ch = supabase.channel("resident_collected_watch")
      .on("postgres_changes", {
        event: "INSERT", schema: "public", table: "activity_logs",
        filter: `property_id=eq.${propertyId}`,
      }, (payload) => {
        if (payload.new?.action === "valet_collected_trash") fetchCollectedIds();
      })
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [propertyId, fetchCollectedIds]);

  const handleSubmit = async () => {
    setSubmitting(true); setSubmitError("");
    try {
      const { error } = await supabase.from("activity_logs").insert({
        property_id: propertyId, user_id: userId,
        action: "resident_trash_submitted",
        metadata: { unit_number: unitNumber, service_date: today },
      });
      if (error) throw error;
      const endsAt = Date.now() + COOLDOWN_MS;
      setCooldownEnd(endsAt); setCooldownDone(false);
      setShowModal(false); fetchSubmissions();
    } catch (err) {
      setSubmitError(err.message || "Submission failed. Please try again.");
    }
    setSubmitting(false);
  };

  const statusConfig    = getStatusConfig(valetStatus);
  const canSubmit       = valetStatus === "on_site" && cooldownDone;
  const todayCount      = submissions.length;
  const latestSub       = submissions[0] || null;
  const latestCollected = latestSub ? collectedIds.has(latestSub.id) : false;

  return (
    <DashboardLayout role="resident" title="My Unit" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--g600)", marginBottom: 6 }}>Resident Portal</div>
        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 4 }}>Welcome home.</h2>
        <p style={{ fontSize: 13, color: "var(--mut)" }}>Unit <strong style={{ color: "var(--g700)" }}>#{unitNumber || "—"}</strong> · {today}</p>
      </div>

      {/* Valet Status Card */}
      <div className="fu d1" style={{ background: statusConfig.bg, border: `1.5px solid ${statusConfig.border}`, borderRadius: 14, padding: "18px 20px", marginBottom: 18, transition: "all .3s" }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>Today's Service Status</div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: statusConfig.dot, flexShrink: 0, boxShadow: valetStatus === "on_site" ? `0 0 0 3px ${statusConfig.dot}33` : "none" }} />
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: statusConfig.color }}>{statusConfig.label}</div>
            <div style={{ fontSize: 12.5, color: "var(--mut)", marginTop: 3, lineHeight: 1.5 }}>{statusConfig.desc}</div>
          </div>
        </div>

        {/* Service Window */}
        {(serviceWindow.start || serviceWindow.end) && (
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px solid ${statusConfig.border}`, display: "flex", alignItems: "center", gap: 8 }}>
            <Clock size={13} color="var(--mut)" />
            <span style={{ fontSize: 12, color: "var(--mut)" }}>
              Service window:{" "}
              <strong style={{ color: "var(--ink)" }}>
                {formatTime12(serviceWindow.start) || "—"}
                {serviceWindow.end ? ` – ${formatTime12(serviceWindow.end)}` : ""}
              </strong>
            </span>
          </div>
        )}
      </div>

      {/* ── Trash Collected Confirmation Banner ── */}
      {latestCollected && (
        <div className="fu d1b" style={{
          display: "flex", alignItems: "center", gap: 12,
          background: "var(--g50)", border: "1.5px solid var(--g300)",
          borderRadius: 14, padding: "16px 20px", marginBottom: 18,
          animation: "fadeUp .3s ease",
        }}>
          <div style={{ width: 40, height: 40, borderRadius: "50%", flexShrink: 0, background: "var(--g600)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PackageCheck size={20} color="#fff" strokeWidth={2} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "var(--g700)", marginBottom: 2 }}>Your trash has been collected</div>
            <div style={{ fontSize: 12.5, color: "var(--mut)" }}>The valet has picked up your trash for today. ✓</div>
          </div>
        </div>
      )}

      {/* Trash Submission Button */}
      <div className="fu d2" style={{ background: "#fff", borderRadius: 14, border: `1.5px solid ${canSubmit ? "var(--g300)" : "var(--ln)"}`, padding: "24px 20px", marginBottom: 18, textAlign: "center", transition: "border-color .3s" }}>
        <div style={{ width: 60, height: 60, borderRadius: "50%", background: canSubmit ? "var(--g50)" : "#f5f5f5", border: `2px solid ${canSubmit ? "var(--g300)" : "#e0e0e0"}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", transition: "all .3s" }}>
          <Trash2 size={26} color={canSubmit ? "var(--g600)" : "#bdbdbd"} strokeWidth={1.5} />
        </div>

        <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", marginBottom: 6 }}>Trash is out</div>
        <div style={{ fontSize: 13, color: "var(--mut)", marginBottom: 18, lineHeight: 1.6 }}>
          {valetStatus === "on_site"
            ? cooldownDone ? "Service in progress — tap below to confirm your submission." : "You already submitted. Wait for cooldown to submit again."
            : valetStatus === "on_the_way" ? "Button will activate when valet arrives on-site."
            : valetStatus === "completed" ? "Today's service is complete."
            : "Button activates when valet arrives on-site."
          }
        </div>

        {submitError && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: "#dc2626", textAlign: "left" }}>
            <AlertCircle size={14} /> {submitError}
          </div>
        )}

        <button onClick={() => canSubmit && setShowModal(true)} disabled={!canSubmit} style={{
          background: canSubmit ? "linear-gradient(135deg, var(--g600), var(--g500))" : "#e0e0e0",
          color: canSubmit ? "#fff" : "#9e9e9e", border: "none", borderRadius: 10,
          padding: "13px 28px", fontSize: 14.5, fontWeight: 700, fontFamily: "'Outfit',sans-serif",
          cursor: canSubmit ? "pointer" : "not-allowed", width: "100%", maxWidth: 300,
          boxShadow: canSubmit ? "0 4px 14px rgba(34,107,65,.3)" : "none", transition: "all .3s",
        }}>
          {valetStatus === "on_site" && !cooldownDone ? "⏳ Cooldown active" : valetStatus === "on_site" ? "✓ Confirm Trash Submission" : "Not available yet"}
        </button>

        {!cooldownDone && cooldownEnd && <CooldownTimer endsAt={cooldownEnd} onExpire={() => setCooldownDone(true)} />}
        {todayCount > 0 && <div style={{ marginTop: 14, fontSize: 12, color: "var(--mut)" }}>You submitted <strong style={{ color: "var(--g600)" }}>{todayCount}</strong> time{todayCount > 1 ? "s" : ""} today.</div>}
      </div>

      {/* Upgrade Banner */}
      <div className="fu d3" style={{ background: "#fff", borderRadius: 14, border: "1px solid var(--ln)", padding: "20px", marginBottom: 18 }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink)", marginBottom: 4 }}>Upgrade Your Service</div>
        <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 12 }}>Get arrival notifications and enhanced cleanliness.</div>
        <button onClick={() => navigate("/resident/services")} style={{ background: "var(--g600)", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>View Plans</button>
      </div>

      {/* Today's Submissions */}
      <div className="fu d4" style={{ background: "#fff", borderRadius: 14, border: "1px solid var(--ln)", padding: "20px" }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 14 }}>Today's Submissions</div>
        {submissions.length === 0 ? (
          <div style={{ textAlign: "center", padding: "16px 0", color: "var(--mut)", fontSize: 13 }}>No submissions today yet.</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {submissions.map((s, i) => {
              const isCollected = collectedIds.has(s.id);
              return (
                <div key={s.id} style={{
                  display: "flex", alignItems: "center", gap: 12,
                  padding: "11px 14px", borderRadius: 10,
                  background: isCollected ? "var(--g50)" : "#fff",
                  border: `1px solid ${isCollected ? "var(--g200)" : "var(--ln)"}`,
                  transition: "all .3s",
                }}>
                  <div style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0, background: isCollected ? "var(--g600)" : "var(--g50)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {isCollected ? <PackageCheck size={15} color="#fff" strokeWidth={2} /> : <CheckCircle2 size={16} color="var(--g600)" strokeWidth={2} />}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
                      {isCollected ? "Trash collected ✓" : `Trash is out — Unit #${unitNumber}`}
                    </div>
                    <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>
                      {new Date(s.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                      {isCollected && <span style={{ marginLeft: 6, color: "var(--g600)", fontWeight: 600 }}>· Collected by valet</span>}
                    </div>
                  </div>
                  {i === 0 && (
                    <span style={{ fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 20, background: "var(--g600)", color: "#fff", textTransform: "uppercase", letterSpacing: ".5px" }}>
                      {isCollected ? "Done" : "Latest"}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {showModal && <ConfirmModal unitNumber={unitNumber} onConfirm={handleSubmit} onCancel={() => { setShowModal(false); setSubmitError(""); }} loading={submitting} />}

      <style>{`@keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </DashboardLayout>
  );
}